import { cn } from '@/lib/utils';

interface InputErrorsProps {
  errors: string[];
}

export function InputErrors({ errors }: InputErrorsProps) {
  if (!errors) {
    return null;
  }

  return (
    <p className={cn('mt-1 text-xs text-red-600')} role="alert" aria-live="polite">
      {errors.join(', ')}
    </p>
  );
}
